<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-5 mx-0 no-gutter">
        <back-button></back-button>
      </b-row>
      <b-row>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input :inputValue="name"
            :inputLabel="$t('common.routing.network.name')"
            :placeholderValue="$t('common.routing.network.name')">
          </form-read-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input :inputValue="norm"
            :inputLabel="$t('common.routing.norm')"
            :placeholderValue="$t('common.routing.norm')">
          </form-read-group-label-input>
        </b-col>
      </b-row>
      <form-accordion :title="$t('common.routing.network.network_bic')" :isTitleUpperCase="false">
        <b-button :disable="activateSpinner"
          @click="addBIC" variant="primary">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.routing.network.add_bic') }}</span>
        </b-button>
        <b-table hover
          class="table table-striped"
          :fields="fields"
          :items="networkBICList"
          :selectable="networkBICList.length > 0"
          :empty-text="$t('errors.No_results_found')" />
      </form-accordion>
    </template>
  </page-outline>
</template>

<script>

import backButton from "@/components/common/backButton.vue"
import FormAccordion from '@/components/common/FormAccordion.vue'
// import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
// import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'RTPNetworkForm',
  components: {
    'back-button': backButton,
    'form-accordion': FormAccordion,
    // 'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput,
    'page-outline': PageOutline
    // 'spinner': Spinner
  },
  props: {
    id: {
      type: String,
      default: '-1'
    }
  },
  data () {
    return {
      activateSpinner: false,
      fields: [
        { key: 'identifier', label: 'BIC', class: 'text-center', sortable: true }
      ],
      name: '',
      nameError: false,
      networkBICList: [],
      norm: '',
      normError: false,
      normOptions: [this.$t('common.norm.srtp'), this.$t('common.norm.giro'), this.$t('common.norm.psd2')],
      pageTitle: ''
    }
  },
  created () {
    this.pageTitle = this.$i18n.t('common.routing.network.details')
    console.log('networkDetails', this.$engine.routing.network.networkDetails)
    this.name = this.$engine.routing.network.networkDetails.name
    this.norm = this.$engine.routing.network.networkDetails.norm
    this.getDetails()
    this.$engine.routing.network.networkDetails = {}
  },
  methods: {
    addBIC () {
      this.$bus.$emit('popup-add-network-bic', {idNetwork: this.id})
    },
    createConfig () {
      let that = this
      if (!this.provider) {
        // mandatory error
      }
      if (!this.norm) {
        // mandatory error
      }
      this.activateSpinner = true
      this.$engine.routing.member.createNorm({
        norm: this.norm,
        idProvider: this.provider
      })
      .then(() => {
        loadPage(that, {url: '/routing/norm/list'})
        that.$f7.alert('', that.$i18n.t('common.routing.norm_added'))
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
      .finally(() => {
        that.activateSpinner = false
      })
    },
    editConfig () {
      let that = this
      this.$engine.routing.member.updateNorm({
        id: this.id,
        norm: this.norm,
        idProvider: this.provider
      })
      .then(() => {
        loadPage(that, {url: '/routing/norm/list'})
        that.$f7.alert('', that.$i18n.t('common.routing.norm_edited'))
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
      .finally(() => {
        that.activateSpinner = false
      })
    },
    getDetails () {
      let that = this
      this.activateSpinner = true
      this.$engine.routing.member.fetch({
        idNetwork: this.id
      })
      .then(resp => {
        that.networkBICList = resp.data.Members
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
        // this.$engine.routing.network.fetch({id: this.id})
        // .then(resp => {
        //   console.log('resp', resp.data)
        // })
        // .catch(err => {
        //   errorMessageAlert(err, that)
        // })
        // .finally(() => {
        //   that.activateSpinner = false
        // })
    }
  }
}

</script>
